import { NavigationBar } from '@travelnest/hui';
import { IBookingsStatistics } from '../../../data/entities/event';
import { IProperty } from '../../../data/entities/property';

import { LinkButton } from '@travelnest/merlin.button';
import * as React from 'react';
import { IAvailabilityV3BookingsResponse } from '../../../api/bookings';
import { BookingList } from '../../components/booking-list/BookingList';
import { ContentHeader } from '../../components/content-header/ContentHeaderContainer';
import { Loader } from '../../components/loader/Loader';
import { Paragraph } from '../../components/paragraph/Paragraph';

export interface IOwnerBookingsProps {
	customerId: string;
	bookings: IAvailabilityV3BookingsResponse;
	statistics: IBookingsStatistics;
	numberOfDays: number;
	properties: IProperty[];
	loading: boolean;
}

export const OwnerBookingsComponent: React.FC<IOwnerBookingsProps> = React.memo(({
	customerId, numberOfDays, loading, statistics = {}, bookings, properties }) => {
	return <>
		<NavigationBar title="Bookings" />
		<div className="portal-wrapper booking-list">
			{
				loading ? <Loader loading={true} message={'Your bookings are loading.'} /> :
					<div className={'owner-bookings'}>
						<section className={'booking-list_performance'}>
							<h2>Performance</h2>
							<Paragraph fontSize="d1">{`Your properties performance over the last ${numberOfDays} days.`}</Paragraph>
							<ul className="performance-information">
								<li className="performance-information_stat">
									<span className="performance-information_title">Bookings</span>
									<span className="performance-information_value">{statistics.num_bookings_last_n_days || 0}</span>
								</li>
								<li className="performance-information_stat">
									<span className="performance-information_title">Guest arrivals</span>
									<span className="performance-information_value">{statistics.num_arrivals_next_n_days || 0}</span>
								</li>
								<li className="performance-information_stat">
									<span className="performance-information_title">Average stay (days)</span>
									<span className="performance-information_value">{statistics.avg_stay_length_last_n_days?.toFixed(2) || 0}</span>
								</li>
								<li className="performance-information_stat">
									<span className="performance-information_title">Average guests</span>
									<span className="performance-information_value">{statistics.avg_num_guests_last_n_days?.toFixed(2) || 0}</span>
								</li>
								<li className="performance-information_stat">
									<span className="performance-information_title">Cancellations</span>
									<span className="performance-information_value">{statistics.num_cancellations_last_n_days || 0}</span>
								</li>
							</ul>
						</section>
						<section className={'upcoming-bookings-list'}>
							<div className={'upcoming-bookings-list_left'}>
								<ContentHeader
									title={'Upcoming bookings'}
									subtext={`View details for your next ${bookings && bookings.data?.length} bookings.`}
									sticky={true}
									childrenRhs={<div className="cont-head__rhs-content--align-right">
										<LinkButton to={`../customer/${customerId}/bookings`}>View all bookings</LinkButton>
									</div>}
								/>
								<BookingList
									bookings={bookings}
									properties={properties}
									loading={loading}
									disablePagination
								></BookingList>
							</div>
							<div className={'upcoming-bookings-list_right'}>
								<div className={'upcoming-bookings-list_cancellations'}>
									<h2 className={'upcoming-bookings-list_title'}>Need to cancel a booking?</h2>
									<p className={'upcoming-bookings-list_copy'}>Remember that confirmed bookings are subject to our <a href="https://travelnest.com/faqs/what-happens-if-a-booking-is-cancelled/" target="_blank">cancellation policy</a> and will result in an admin fee.</p>
									<a href="https://docs.google.com/forms/d/e/1FAIpQLSfCh6_ouBbWTK28vbG1OtWwnpuQGI84mnPDLiMppzxx1TwG9A/viewform" target="_blank" className={'upcoming-bookings-list_huibutton'}>Request a cancellation</a>
								</div>
							</div>
						</section>
					</div>
			}
		</div>
	</>;
});
